import { getAuthData } from "@common/helpers/auth";
import { broadcast, broadcastChannels } from "@common/helpers/broadcast";
import { fetchRequest, swarmRequest } from "@common/helpers/util/requestMiddleware";
import { TicketTypes } from "@tickets/constants";
import { getBetPlayerPaymentInfoBulk, resetPlayerPaymentInfo, setPlayerPaymentInfo } from "../actions/terminal";
import Config from "@skin_config";
import { TerminalDepositModesEnum } from "../constants/enums/terminalDepositModes";
import { store } from "../index/terminalApp";

export const SessionBalanceStates = {
  Neutral: 0,
  Cash: 1,
  NonCash: 2,
};

export const sessionAndTerminalStateMap = {
  [SessionBalanceStates.NonCash]: TerminalDepositModesEnum.Octo,
  [SessionBalanceStates.Cash]: TerminalDepositModesEnum.Cash,
  [SessionBalanceStates.Neutral]: TerminalDepositModesEnum.Ticket,
};

const BetSource = {
  Sport: 1,
  Casino: 2,
};

export const TicketTypeBetSourceMap = {
  [TicketTypes.SPORT]: BetSource.Sport,
  [TicketTypes.CASINO]: BetSource.Casion,
};

class PaymentsService {
  static playerDataSetted = false;

  static async getSessionBalanceState() {
    const { token } = getAuthData() || {};

    const stateResponse = await swarmRequest(
      {
        name: "GetSessionBalanceState",
        params: { Token: token },
      },
      "terminal_command"
    );

    const sessionBalanceState = stateResponse.data?.SessionBalanceState;

    const finalState = sessionAndTerminalStateMap[sessionBalanceState];

    if (!stateResponse.data) return { state: TerminalDepositModesEnum.Ticket, playerInfo: {} };

    return {
      state: finalState,
      playerInfo: stateResponse.data,
    };
  }

  static async setPlayerInfo(playerData) {
    const { tid } = getAuthData() || {}

    store.dispatch(setPlayerPaymentInfo(playerData))
    try {
      if (this.playerDataSetted) return;

      await fetchRequest(
        Config.casino.middlewareUrl,
        `api/CashdeskDetails/SetDetailsByCashdeskId?token=${Config.casino.middlewareAuthToken}`,
        "POST",
        {
          body: {
            CashdeskId: +tid,
            CashdeskDetails: JSON.stringify(playerData)
          }
        }
      );

      this.playerDataSetted = true
    } catch { }

  };

  static async setSessionBalanceState(stateInfo) {
    const { token, tid } = getAuthData() || {};
    await swarmRequest(
      {
        name: "SetSessionBalanceState",
        params: {
          Token: token,
          ...stateInfo,
        },
      },
      "terminal_command"
    );
  }

  static async clearSessionBalanceState() {
    const { token, tid } = getAuthData() || {};

    sessionStorage.setItem("payedTicketsAmount", 0);
    await swarmRequest({ token }, "terminal_clear_session_balance_state");
    await fetchRequest(Config.casino.middlewareUrl, `api/CashdeskDetails/RemoveDetailsByCashdeskId/${tid}?token=${Config.casino.middlewareAuthToken}`, 'DELETE')
    this.playerDataSetted = false;
    store.dispatch(resetPlayerPaymentInfo());
  }

  static getBetPlayerPaymentInfo(ticketsList) {
    return new Promise((resolve) => {
      const onResponse = (e) => resolve(e.detail);

      broadcast.addEventListener(broadcastChannels.ReceiveBetPaymentInfos, onResponse, { once: true });

      store.dispatch(getBetPlayerPaymentInfoBulk(ticketsList));
    });
  }

  static getSessionBalanceEmptyState() {
    // method for not making state get call when balance is 0

    const authData = getAuthData();

    const stateData = {
      Id: "",
      BetId: "",
      Source: 0,
      CashdeskId: +authData.tid,
      PaymentsPlayerId: "",
      SessionBalanceState: 0,
      PaymentSystemId: 0,
      PaymentsRequestId: "",
      Name: "",
      Surname: "",
      PersonalId: "",
    };

    return stateData;
  }
}

export default PaymentsService;
